import { handleAudioUploadCompleted } from 'resources/episode';
import Modal from 'shared/components/modal';
import uploader from 'services/file-upload';
import MimeTypes from 'shared/helpers/mime-types';
import store from '../../app/store';
import {
  updateAudioMarkerWithDuration,
  updateAudioMarkerWithMedia,
  deleteMarkers,
} from '../../ducks/markers';
import { getAdMarkers, getAudioMarker } from './markers';
import { uploadEpisodeAudio } from './upload-episode-audio';

function abortAudioUpload(audio) {
  if (audio) {
    uploader.abort(audio.id, 'media');
  }
}

function userConfirmsContinue() {
  return Modal.present({
    title: 'Replace audio file?',
    dialog:
      'If you replace the audio file, the ad markers will be reset. Do not forget they will need to be moved in order to publish the episode.',
    actions: [
      { name: 'Cancel', value: false, variant: 'tertiary' },
      { name: 'Replace', value: true, variant: 'primary', intent: 'danger' },
    ],
  }).then(isConfirmed => {
    if (!isConfirmed) {
      return Promise.reject(new Error('File upload canceled by user.'));
    }
    return null;
  });
}

function onUpdateAudioMarkerWithDuration(...args) {
  return store.dispatch(updateAudioMarkerWithDuration(...args));
}

function onUpdateAudioMarkerWithMedia(...args) {
  return store.dispatch(updateAudioMarkerWithMedia(...args));
}

function deleteAdMarkers(markers) {
  const adMarkers = getAdMarkers(markers);
  return store.dispatch(deleteMarkers(adMarkers));
}
/* eslint-disable no-unused-expressions */
async function beginAudioUpload({ audioMarker, file, markers, episodeId, showId }) {
  if (!audioMarker || !file) {
    throw new Error('Missing parameters');
  }

  await userConfirmsContinue();
  const url = await uploadEpisodeAudio({
    audioMarker,
    episodeId,
    file,
    onUpdateAudioMarkerWithMedia,
    onUpdateAudioMarkerWithDuration,
    showId,
  });

  await deleteAdMarkers(markers);
  return url;
}
/* eslint-enable no-unused-expressions */

function uploadAudio({ episodeId, showId, audioMarker, file, markers }) {
  beginAudioUpload({ audioMarker, file, markers, episodeId, showId })
    .then(mediaUrl => handleAudioUploadCompleted(episodeId, mediaUrl))
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log(error.message);
    });
}

function confirmAbortUpload({ episodeId, showId, audioMarker, file, markers }) {
  Modal.present({
    title: 'Are you sure?',
    dialog: 'Are you sure you want to abort the current upload?',
    actions: [
      { name: 'Cancel', value: false, variant: 'tertiary' },
      { name: 'Abort', value: true, variant: 'primary', intent: 'danger' },
    ],
  }).then(confirm => {
    if (confirm) {
      abortAudioUpload(audioMarker);
      uploadAudio({ episodeId, showId, audioMarker, file, markers });
    }
  });
}

export default function replaceEpisodeAudioFile(episodeId, showId, file, markers = []) {
  if (MimeTypes.Audio.indexOf(file.type) === -1) {
    return;
  }

  const audioMarker = getAudioMarker(markers);

  if (audioMarker) {
    const current = uploader.get(audioMarker.id, 'media');

    if (current) {
      confirmAbortUpload({ episodeId, showId, audioMarker, file, markers });
    } else {
      uploadAudio({ episodeId, showId, audioMarker, file, markers });
    }
  }
}
